import { Directive, ElementRef, HostListener, Output, EventEmitter, inject } from '@angular/core';

@Directive({
    selector: '[appClickOutside]',
    standalone: false
})
export class ClickOutsideDirective {
    private elementRef = inject(ElementRef);

    @Output() appClickOutside = new EventEmitter<void>();

    @HostListener('document:click', ['$event.target'])
    public onClick(target: HTMLElement) {
        const clickedInside = this.elementRef.nativeElement.contains(target);

        if (!clickedInside) {
            this.appClickOutside.emit();
        }
    }

}
